import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {WalletCard, WalletCardStyle} from "../../../ui/WalletCard";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle, Theme} from "../../../../../stem-core/src/ui/style/Theme";
import {PaymentMethodStore, WalletStore} from "../../../../State";
import {RollAnimatedBalance} from "../../../../common/RollAnimatedBalance";
import {WalletRadioButtons} from "../../../ui/WalletButton";
import {AddFundsButton} from "../components/AddFundsButton";
import {AutoReload} from "../components/AutoReload";
import {CardInline} from "../../../components/CardInline";
import {Money} from "../../../../../client/state/misc/Money";
import {TOP_UP_VALUES} from "../../../../Constants";


export const addFundsBalanceStyle = {
    fontSize: 48,
    height: "1em",
    fontWeight: 200,
    display: "block",
    transform: "none !important",
    margin: "24px 0 36px",
    color: Theme.props.WALLET_BALANCE_COLOR,
};

export class AddFundsExpandedStyle extends WalletCardStyle {
    @styleRuleInherit
    card = {
        minHeight: "",
    };

    @styleRuleInherit
    content = {
        overflow: "hidden",
    };

    @styleRule
    label = {
        color: this.themeProps.LABEL,
        userSelect: "none",
        "-webkit-user-select": "none",
    };

    @styleRule
    line = {
        marginTop: 18,
    };

    @styleRule
    balance = {
        ...addFundsBalanceStyle,
        opacity: 0,
    };

    @styleRule
    horizontalPadding = {
        padding: "0 24px",
    };

    @styleRule
    spaceFill = {
        flex: 1,
        transition: "unset",
    };
}

@registerStyle(AddFundsExpandedStyle)
export class AddFundsExpanded extends WalletCard {
    activeValue;

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            testId: "addFundsExpanded",
        }
    }

    getCurrency() {
        return WalletStore.getWallet().getCurrency();
    }

    renderAdvancedSection() {
        const {styleSheet} = this;
        if (!PaymentMethodStore.getPrimary()) {
            return null;
        }
        return [
            <CardInline className={styleSheet.line} hideIcon={true}/>,
            <AutoReload className={styleSheet.line} style={{marginBottom: 4}}/>
        ];
    }

    render() {
        const {styleSheet} = this;

        const reloadOptions = TOP_UP_VALUES.map(value => this.mainUnitsToOption(value));
        this.activeValue = this.activeValue || reloadOptions[1];

        const onRadioSelect = value => {
            this.activeValue = value;
            this.redraw();
        };

        return [
            <RollAnimatedBalance ref="balance" className={styleSheet.balance}/>,
            <div className={styleSheet.horizontalPadding}>
                <WalletRadioButtons ref="radioButtons" testId="addFundsAmountButtons" activeValue={this.activeValue}
                                    values={reloadOptions} onSelect={onRadioSelect}/>
                {this.renderAdvancedSection()}
            </div>,
        ];
    }

    mainUnitsToOption(amount) {
        return (new Money(this.getCurrency().mainUnitsToAmount(amount), this.getCurrency())).toMainUnitString({decimalsDisplayed: 0});
    }

    getAmountByOption(option) {
        return this.getCurrency().mainUnitsToAmount(
            TOP_UP_VALUES.find(value => this.mainUnitsToOption(value) === option));
    }

    renderPrimaryButton() {
        return <AddFundsButton ref="button" testId="addFundsButton" amount={this.getAmountByOption(this.activeValue)}/>;
    }

    prepareScrollableContent() {}

    onMount() {
        super.onMount();

        this.attachChangeListener(PaymentMethodStore, () => this.redraw());
        this.attachChangeListener(WalletStore, () => this.redraw());
    }
}
